<script setup>
const metadata = useMetadata()
defineProps({
  useBold: {
    type: Boolean,
    default: false,
  },
  includeFromWord: {
    type: Boolean,
    default: true,
  },
  withHoursLong: {
    type: Boolean,
    default: false,
  },
  withHoursShort: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <span>
    <a
      :href="`tel:${metadata?.customerService?.number}`"
      :style="{ fontWeight: useBold ? 'bold' : 'normal' }"
    >
      {{ metadata?.customerService?.numberDisplay }}
    </a>
    <span v-if="withHoursShort">
      <span v-if="includeFromWord"> from </span>
      {{ metadata?.customerService?.hoursShort }}
    </span>
    <span v-if="withHoursLong">
      <span v-if="includeFromWord"> from </span>
      {{ metadata?.customerService?.hoursLong }}
    </span>
  </span>
</template>
